export enum ChartType {
  Line = 'line',
  Mountain = 'mountain',
  HLC = 'hlc',
  Candle = 'candle',
}
